export interface HotelReviewData {
  score: number;
  scoreFormatted: string;
  word: string;
  count: number | null;
  countFormatted: string | null;
}

export function formatReviewScore(score: number): string {
  return score.toFixed(1);
}

export function formatHotelPageReviewScore(score: number): string {
  return score === 10 ? '10' : score.toFixed(1);
}

export function hotelPageReviewScoreColor(score: number): string {
  if (score >= 10) return '#102C8C';
  if (score >= 8) return '#3159C7';
  if (score >= 7) return '#5B7DE0';
  return '#2878A8';
}

export function reviewWord(score: number): string {
  if (score >= 9.5) return 'Exceptional';
  if (score >= 9.0) return 'Superb';
  if (score >= 8.5) return 'Fabulous';
  if (score >= 8.0) return 'Very good';
  if (score >= 7.0) return 'Good';
  return 'Pleasant';
}

/**
 * Review summary for hotel cards (search listings, carousels). Only ever shows
 * the supplier's verified guest score and count. A hotel without a score gets
 * `null` and the card shows no review badge; a score without a count shows
 * the score alone. Never synthesise either: a made-up rating is a fake review.
 */
export function getHotelReviewData(hotel: {
  reviewScore?: number | null;
  reviewCount?: number | null;
}): HotelReviewData | null {
  if (typeof hotel.reviewScore !== 'number' || !(hotel.reviewScore > 0)) {
    return null;
  }
  const score = Number(hotel.reviewScore.toFixed(1));
  const count = typeof hotel.reviewCount === 'number' && hotel.reviewCount > 0 ? hotel.reviewCount : null;
  return {
    score,
    scoreFormatted: formatReviewScore(score),
    word: reviewWord(score),
    count,
    countFormatted: count === null ? null : `${count.toLocaleString()} ${count === 1 ? 'review' : 'reviews'}`,
  };
}
